<template>
    <div class="container">
    <div class="masa">
            <button title="Close window" @click="closeWindow"><i title="close window" style="transform: rotate(45deg);" class="fas fa-plus"></i></button>
            <h2> أذكار المساء </h2>
            <div>
                <p>
                    أمسينا وأمسى الملك لله والحمد لله ، لا اله إلا الله وحده لا شريك له ، له الملك وله الحمد ، وهو على
                    كل شيء قدير ، ربي أسألك خير ما في هذا الليلة وخير ما بعدها ، أعوذ بك من شر ما في هذا الليلة وشر ما
                    بعدها ، ربي أعوذ بك من الكسل وسوء الكبر ، ربي أعوذ بك من عذاب في النار وعذاب في القبر
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>[ مختصر مسلم : 1894 ]</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    بسم الله الـذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم
                </p>
                <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>[ صحيح الترميذي : 3388 ]</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    أعوذ بكلمات الله التامات من شر ما خلق
                </p>
                <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>[ مختصر مسلم : 1453 ]</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    اللهم أنت ربي لا إله إلا أنت خلقتني وأنا عبدك وأنا على عهدك ووعدك ما استطعت أعوذ بك من شر ما صنعت
                    أبوء لك بنعمتك علي وأبوء بذنبي فاغفر لي فإنه لا يغفر الذنوب إلا أنت.
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح البخاري : 2420</span>
                <!-- 
                    <i>من قالها حينما يمسي مؤمنا بها موقنا بها فمات من ليلته دخل الجنة</i>
                    -->
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة آية الكرسي </strong>
                <p>
                    اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَهُ مَا فِي
                    السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا
                    بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلاَّ بِمَا شَاءَ
                    وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَئُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيم
                </p>
                <span>مرة واحدة</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح الترغيب : 658</span>
                
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة الآيتين الأخيرتين من سورة البقرة </strong>
                <p>
                    آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ كُلٌّ آمَنَ بِاللَّهِ
                    وَمَلائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ وَقَالُوا سَمِعْنَا
                    وَأَطَعْنَا غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ *لا يُكَلِّفُ اللَّهُ نَفْسًا إِلا وُسْعَهَا
                    لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ
                    أَخْطَأْنَا رَبَّنَا وَلا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا
                    رَبَّنَا وَلا تُحَمِّلْنَا مَا لا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا
                    أَنْتَ مَوْلانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِين.َ
                </p>
                <span title="null"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span title="null"></span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة سورة الناس </strong>
                <p>
                    قُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ، مَلِكِ ٱلنَّاسِ، إِلَٰهِ ٱلنَّاسِ، مِن شَرِّ ٱلْوَسْوَاسِ
                    ٱلْخَنَّاسِ، ٱلَّذِى يُوَسْوِسُ فِى صُدُورِ ٱلنَّاسِ، مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ
                </p>
                <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح الكلم : 18 </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة سورة الفلق </strong>
                <p>
                    قُلْ أَعُوذُ بِرَبِّ ٱلْفَلَقِ، مِن شَرِّ مَا خَلَقَ، وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِن شَرِّ
                    ٱلنَّفَّٰثَٰتِ فِى ٱلْعُقَدِ، وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ
                </p>
                <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح الكلم : 18 </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة سورة الإخلاص </strong>
                <p>
                    قُلْ هُوَ ٱللَّهُ أَحَدٌ، ٱللَّهُ ٱلصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُن لَّهُۥ كُفُوًا
                    أَحَدٌۢ
                </p>
                <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح الكلم : 18 </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p> لا إلهَ إلاّ اللّهُ وحْـدَهُ لا شريكَ لهُ، لهُ المُلكُ ولهُ الحَمْد، يُحيـي وَيُمـيتُ وهُوَ على كُلّ
                    شيءٍ قدير </p>
                <span> عَشْر مَرّات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> الصحيحة : 2563</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i
                            class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            

                
        </div>
    </div>
</template>

<script>
import { copyShare } from "./sharing"
import { teleShare } from "./sharing"
import { twitterShare } from "./sharing"
import { waShare } from "./sharing"
export default {

    mounted() {
        copyShare();
        teleShare();
        twitterShare();
        waShare();
    },
    methods: {
        closeWindow() {
            this.$emit("closeMasa", false);
        }
    }
}
</script>